import {makeTrackEvent} from './makeTrackEvent';

export type WorkspaceDragAndDropAction =
  | 'Reorder sections'
  | 'Reorder panel within section'
  | 'Drag panel to different section';

export const trackWorkspaceDragAndDrop = makeTrackEvent<
  {
    action: WorkspaceDragAndDropAction;
    layoutType?: 'grid' | 'flow';
  },
  {
    action: {
      description: 'what type of drag and drop action was performed';
      exampleValues: [
        'Reorder sections',
        'Reorder panel within section',
        'Drag panel to different section'
      ];
    };
    layoutType: {
      description: 'the type of section the drag and drop action was performed in';
      exampleValues: ['grid', 'flow'];
    };
    _description: 'Tracks events related to drag and drop in workspaces';
    _location: 'multi-run, group, and sweep workspaces';
    _motivation: 'track usage';
  }
>('Workspace drag and drop');
